/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { blogRssBaseUrl } from "../../config/api";
import { SkeletonBlogCard } from "../../Components";

import axios from "axios";
import "./Blog.css";

// دالة صغيرة لتنظيف النص من أكواد HTML
const stripHtml = (html) => {
  let doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

// دالة لإيجاد أول صورة داخل النص
const extractFirstImage = (html) => {
  let doc = new DOMParser().parseFromString(html, "text/html");
  let img = doc.querySelector("img");
  return img.src;
};

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const res = await axios.get(blogRssBaseUrl);

        const cleanPosts = res.data.items.map((item) => ({
          title: item.title,
          link: item.link,
          date: new Date(item.pubDate).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          }),
          category: item.categories.length > 0 ? item.categories[0] : "General",
          image: extractFirstImage(item.description),
          description: stripHtml(item.description).slice(0, 120) + "...",
        }));

        setPosts(cleanPosts);
      } catch (err) {
        console.error("Error fetching RSS feed:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return (
    <>
      {/* #BLOG */}
      <article className="blog" data-page="blog">
        <header>
          <h2 className="h2 article-title">Blog</h2>
        </header>
        <section className="blog-posts">
          <ul className="blog-posts-list">
            {loading
              ? Array(4) // show 4 skeletons while loading
                  .fill(null)
                  .map((_, i) => <SkeletonBlogCard key={i} />)
              : posts.map((post, index) => (
                  <li key={index} className="blog-post-item">
                    <a
                      href={post.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <figure className="blog-banner-box">
                        <LazyLoadImage
                          src={post.image}
                          alt={post.title}
                          effect="blur"
                          placeholderSrc={post.title}
                        />
                      </figure>
                      <div className="blog-content">
                        <div className="blog-meta">
                          <p className="blog-category">{post.category}</p>
                          <span className="dot"></span>
                          <time dateTime={post.date}>{post.date}</time>
                        </div>
                        <h3 className="h3 blog-item-title">{post.title}</h3>
                        <p className="blog-text">{post.description}</p>
                      </div>
                    </a>
                  </li>
                ))}
          </ul>
        </section>
      </article>
    </>
  );
};

export default Blog;
